import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import FormAuth from './authForms/FormAuth'
import FormRestore from './authForms/FormRestore'

const ModalAuth = ({ isShow, handleClose, inputsData, handleRegister }) => {

    const [tabContent, setTabContent] = useState(1)
    const [isAllowClose, setIsAllowClose] = useState(true)

    const setIsAllowClear = (val) => {
        setIsAllowClose(val)
    }

    useEffect(() => {
        if (isShow) setTabContent(1)
    }, [isShow])



    return (
        <Modal
            show={isShow}
            onHide={() => {
                if (isAllowClose) handleClose()
            }}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="modal-login"
        >
            <Modal.Header style={{ padding: '12px 30px 0 0' }}>
                <button
                    className='btn p-2 ml-auto'
                    onClick={() => {
                        handleClose()
                    }}
                    style={{ position: 'relative', zIndex: 100, }}
                >
                    <span style={{ color: '#000' }}>&#x2715;</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                {
                    tabContent === 1 &&
                    <FormAuth
                        inputsData={inputsData}
                        tabs={(e) => { setTabContent(e) }}
                        handleRegister={handleRegister}
                        handleClose={handleClose}
                    />
                }
                {
                    tabContent === 2 &&
                    <FormRestore tabs={(e) => { setTabContent(e) }} inputsData={inputsData} setIsAllowClear={setIsAllowClear} />
                }
            </Modal.Body>
        </Modal>
    )
}

export default ModalAuth